import PositionStatus from '@/enums/positionStatus';

export default {
	methods: {
		getStatusChipColor(value) {
            switch (parseInt(value)) {
                case 0:
                    return 'warning';
                case 1:
                    return 'success';
                case 10:
                    return 'success';
            }
            return '';
        },
        getStatusChipTextColor(value) {
            if (parseInt(value) !== 1) {
                return 'white';
            }

            return '';
        },
        getStatusChipOutline(value) {
            if (parseInt(value) === 1) {
                return true;
            }

            return false;
        },
        getStatusFriendly(value) {
            switch (parseInt(value)) {
                case 0:
                    return 'Draft';
                case 1:
                    return 'Approved';
                case 10:
                    return 'Live';
            }
            return '';
        },
        isApproved(position) {
            return position.status === PositionStatus.Approved || position.approval != null;
        },
        isAcknowledged(position) {
            return position.employeeAcknowledgement != null;
        },
        isAcknowledgedBySystemAdmin(position) {
            return this.getAcknowledgedBy(position) === "System Admin";
        },
        getAcknowledgedBy(position, employeeName = "employee") {
            // Fallback to employee name if not set on position
            if (!position.employeeAcknowledgement || !position.employeeAcknowledgement.acknowledgedBy)
                return employeeName;

            return `${position.employeeAcknowledgement.acknowledgedBy.firstName} ${position.employeeAcknowledgement.acknowledgedBy.lastName}`.trim();
        },
        isApprovedPendingAcknowledgement(position) {
            return position.status === PositionStatus.Approved && this.isApproved(position) && !this.isAcknowledged(position);
        },
        isDraft(position) {
            return position.status === PositionStatus.Draft;
        },
        isLive(position) {
            return position.status === PositionStatus.Live;
        },
        areThereAnyLive(positions) {
            return positions.some(x => this.isLive(x));
        },
        areThereNewerLive(position, positions) {
            return positions.some(x => this.isLive(x) && new Date(x.startDateUTC) > new Date(position.startDateUTC));
        },
        isCurrent(position, positions) {
            return this.isLive(position) && !this.areThereNewerLive(position, positions)
        }
	}  
};
